<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.main
	background:#FCFCFC;
	padding:0 15%;
	.title
		display:flex;
		flex-direction:column;
		align-items:center;
		padding-top:50px;
		margin-bottom:40px;
		.t-main
			height:59px;
			font-size:42px;
			font-weight:400;
			color:rgba(7,19,54,1);
			line-height:59px;
			margin-bottom:10px;
		.t-desc
			height:22px;
			font-size:16px;
			font-weight:400;
			color:rgba(7,19,54,0.4);
			line-height:22px;
	.classify-list
		width:1321px;
		height:59px;
		margin-top:0px;
		.list-box
			height:59px;
			margin-left:20px
			display:flex;
			align-items:center;
			.list-sel
				height:27px;
				padding:0 10px;
				line-height:27px;
				background:rgba(39,81,203,1);
				border-radius:20px;
				font-size:14px;
				font-weight:400;
				color:rgba(255,255,255,1);
				text-align:center;
				margin-right:20px;
				cursor:pointer
			.list-not
				height:27px;
				padding:0 10px;
				line-height:27px;
				border-radius:20px;
				font-size:14px;
				font-weight:400;
				color:#676F86;
				text-align:center;
				margin-right:20px;
				cursor:pointer;
	.course-list
		margin-top:10px;
		display:flex;
		flex-wrap: wrap;
		width:1374px;
		margin-bottom:70px;
		.noList
			text-align:center;
			width:1321px;
			margin-top:200px;
			font-size:20px;
		.courseing
			box-shadow:0px 2px 27px 0px rgba(0,84,116,0.11);
			width: 414px;
			height: 179px;
			border-radius: 10px;
			margin: 20px 16px;
			display:flex;
			position: relative;
			cursor:pointer;
		  	.list-img
				width: 414px;
				height: 179px;
				border-radius: 10px;
		  	.course-lists
				margin-right: 24px;
				position: absolute;
				left: 140px;
				top:30px;
				.l-title
					height:50px;
					font-size:18px;
					font-weight:500;
					color:rgba(7,19,54,1);
					line-height:25px;
					overflow: hidden;
					display: -webkit-box;
					text-overflow:ellipsis;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
				.l-name
					height:20px;
					font-size:14px;
					font-weight:400;
					color:rgba(7,19,54,0.6);
					line-height:20px;
					margin-top:7px;
				.l-time
					height:20px;
					font-size:14px;
					font-weight:400;
					color:rgba(7,19,54,0.6);
					line-height:20px;
					margin-top:2px;
				.l-btn
					display: flex;
					margin-top:6px;
					.l-type
						// width:85px;
						padding:0 10px;
						height:24px;
						line-height:24px;
						background:rgba(209,173,10,1);
						border-radius:12px;
						color: #ffffff;
						text-align: center;
						margin-right:6px;
  					.l-type-fldjt
						background-color: #5C607D;
  					.l-type-no
						background-color: #A3AB5F;
  					.l-sign
						width:60px;
						height:24px;
						line-height:24px;
						background:rgba(33,177,104,1);
						border-radius:12px;
						color: #ffffff;
						text-align: center;
  					.l-over
						background:rgba(185,185,185,1);
	.bottom
		padding-bottom:70px;
		text-align:center;
</style>
<template>
  <div class="main">
    <div class="title">
    	<div class="t-main">企业法务通</div>
    	<div class="t-desc">- COURSE TRAINING -</div>
    </div>
    <div class="classify-list">
    	<div class="list-box">
    		<div :class="checkNum === 0 ? 'list-sel' : 'list-not'" @click="selAll">全部</div>
    		<div :class="checkNum == item.id ? 'list-sel' : 'list-not'" v-for="(item,index) in tabList" :key="index" @click="selClassify(item.id)">{{item.tag_name}}</div>
    	</div>
    </div>
    <div class="course-list">
    	<div v-if="!courseList.length" class="noList">暂时没有课程</div>
    	<div v-else v-for="(item , index) in courseList" :key="index"  class="courseing" @click="toCourse(item.id)">
			<img :src="item.cover" class="list-img">
			<div class="course-lists">
				<div class="l-title">{{item.title}}</div>
				<div class="l-name">主讲人：{{item.speaker}}</div>
				<div class="l-time">活动时间：{{item.start_time}}-{{item.end_timehm}}</div>
				<div class="l-btn">
					<!-- <div class="l-type" v-if="item.catagory == '企业法务通'">{{item.catagory}}</div> -->
					<!-- <div class="l-type l-type-fldjt" v-else-if="item.catagory == '法律大讲堂'">{{item.catagory}}</div> -->
					<!-- <div class="l-type l-type-no" v-else>{{item.catagory}}</div> -->
					<div class="l-type">{{item.tag_name}}</div>
					<div v-if="item.issign" class="l-sign">报名中</div>
        			<div v-else class="l-sign l-over">已结束</div>
				</div>
			</div>
    	</div>
    </div>
    <div class="bottom" v-if="total > perpage">
	    <el-pagination
		  background
		  :current-page.sync="page"
          :page-size="perpage"
          @current-change="handleCurrentChange"
		  layout="prev, pager, next, total"
		  :total="total">
		</el-pagination>
	</div>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'MoreCourse',
  data () {
    return {
      tabList:[],
      checkNum : 0,
      courseList:[],
      page:1,
      total:0,
      perpage: 9,
    }
  },
  mounted(){
  	this.checkNum = this.$route.query.id || 0;
  	this.getCourse();
  	this.getTagList();
  },
  methods:{
  	//获取标签列表
  	getTagList(){
  		let url = 'wxm/course/getTags';
  		this.$http.get(url).then(res => {
  			if(res.data.retcode == $conf.RETCODE_OK){
  				this.tabList = res.data.data;
  			}
  		})
  	},
  	//全选
  	selAll(){
  		this.checkNum = 0;
  		this.getCourse();
  	},
  	//选择标签
  	selClassify(id){
  		this.checkNum = id;
  		this.getCourse();
  	},
  	getCourse(){
  		let url = 'wxm/course/index';
  		let param = {
  			page:this.page,
  			per_page:this.perpage,
  			tag_id:this.checkNum
  		};
  		this.$http.get(url, {params:param} ).then(res => {
  			if(res.data.retcode == $conf.RETCODE_OK){
  				var datas = res.data.data.data;
  				var timestamp = Date.parse(new Date());
        		timestamp = timestamp / 1000;
        		for(var i = 0 ; i <datas.length ; i++){
		          datas[i].start_time = moment(datas[i].start_time * 1000).format("YYYY-MM-DD HH:mm");
		          if (datas[i].end_time > timestamp){
		            datas[i].issign = true;
		          }else{
		            datas[i].issign = false;
		          };
		          datas[i].end_timehm = moment(datas[i].end_time * 1000).format("HH:mm");
		        };
		        this.courseList = datas;
		        this.total = res.data.data.total;
  			}
  		})
  	},
  	toCourse(id){
  		this.$router.push({path:'/course/' + id})
  	},
  	handleCurrentChange(val) {
      this.page = val
      this.getCourse()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/legalCourse/moreCourse.vue